"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorTypes = void 0;
exports.errorTypes = [
    'Dependency',
    'Evaluation',
    'Exclusions',
    'ListLength',
    'ValueRule',
    'ValueType',
    'ValueFunction',
];
const errorClasses = Object.fromEntries(exports.errorTypes.map((typeName) => [
    `${typeName}Error`,
    class extends Error {
        constructor(message) {
            super(message);
            this.name = `${typeName}Error`;
        }
    },
]));
exports.default = errorClasses;
